import React from "react";
import PathConstants from "./pathConstants";
import QRScannerPage from "../pages/qr-scanner";
import AttendanceRecordsPage from "../pages/attendance-records";
const HomePage = React.lazy(() => import("../pages/home/index"));

const routes = [
    { path: PathConstants.HOME, element: <HomePage /> },
    { path: PathConstants.QrScanner, element: <QRScannerPage /> },
    { path: PathConstants.Attendance, element: <AttendanceRecordsPage /> },
];

export default routes;
